import { Component, OnInit } from '@angular/core';
import { QuizSession } from '../model/quiz-session.model';
import { StorySession } from '../model/story-session.model';
import { TeacherService } from '../teacher/teacher.service';

@Component({
  selector: 'app-story-session',
  templateUrl: './story-session.component.html',
  styleUrls: ['./story-session.component.scss']
})
export class StorySessionComponent implements OnInit {

  storySessions: StorySession[];
  displayedColumns: string[] = [
    'storySession.storybookName',
    'storySession.studentUsername',
    'storySession.expPoints',
    'storySession.createdDate'
  ];
  tableReady: boolean = false;
  items = [];
  pageOfItems: Array<any>;
  constructor(
    private teacherService: TeacherService
  ) { }

  ngOnInit(): void {
    let avatarUser = JSON.parse(localStorage.getItem("avatarUser"));
    this.storySessions = [];
    this.teacherService.getLatestStorySessionsByStudentId(avatarUser.teacherId).subscribe((allStorySessions: StorySession[]) => {
      console.log(allStorySessions);
      this.storySessions = allStorySessions;
      this.items = this.storySessions;

      this.displayTable();
    });
  }

  displayTable(){
    this.tableReady = true;
  }


  onChangePage(pageOfItems: Array<any>) {
    // update current page of items
    this.pageOfItems = pageOfItems;
  }
}
